<template>
    <div class="workpostscanproduct" id="workpostscanproduct" style="">
        <workstation-scan-products
            v-if="workpost"
            :workstation="workpost"
            ref="scanner"
            :action-buttons="actionButtons"></workstation-scan-products>
    </div>
</template>
<script>
import workstationScanProducts from '../components/scanProducts/WorkstationScanProducts';
import exportApi from '../api/export';
import workstationApi from '../api/workstation';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    mixins: [localization],
    computed: {
        selectedPrinterPostParameter() {
            return this.$store.getters[
                'printers/getSelectedPrinterPostParameter'
                ]();
        },
    },
    data() {
        return {
            workpost: null,
            actionButtons: [
                {
                    label: this.trans('pages.workpost_scan_product.print_cnc_label'),
                    action: (productId) => {
                        if (KeyHelper.isPressed('Shift')) {
                            return window.open(
                                Config.url +
                                    '/export/exportCNCBarcodeLabelForProduct/' +
                                    '?productId=' +
                                    productId
                            );
                        }

                        exportApi
                            .printCNCBarcodeLabelForProduct(
                                productId,
                                this.selectedPrinterPostParameter
                            )
                            .then(() => {
                                showInfoMessage(this.trans('pages.workpost_scan_product.cnc_label_printed'));
                            })
                            .catch(() => {
                                showErrorMessage(
                                    this.trans('pages.workpost_scan_product.cnc_label_print_error')
                                );
                            });
                    },
                },
            ],
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$refs.scanner.beforeRouteLeave(to, from, next);
    },
    mounted() {
        workstationApi.fetchByCustomView('#workpostcnc').then((response) => {
            this.workpost = response.data.data;
        });
    },
    components: {
        workstationScanProducts,
    },
};
</script>
